import React from 'react';

import { ICellRendererParams, RowNode } from 'ag-grid-community';

import EllipsisText from 'components/EllipsisText/EllipsisText';
//eslint-disable-next-line no-restricted-imports
import MessageTooltip from 'components/MessageTooltip/MessageTooltip';

import block from 'utils/bem-css-modules';
import { formatMessage } from 'utils/messages/utils';

import style from './TextRenderer.module.pcss';

const b = block(style);

interface TextRendererProps extends ICellRendererParams {
  onCellClick?: (data: RowNode) => void;
  isTooltipDisplayed?: boolean;
  'data-testid'?: string;
}

export const TextRenderer: React.FC<TextRendererProps> = (props: TextRendererProps) => {
  const { value, data, colDef, onCellClick, isTooltipDisplayed = false } = props;

  if (!data) {
    return null;
  }

  const isClickable = !!onCellClick;

  const handleClick = (event) => {
    event.preventDefault();
    event.stopPropagation();

    if (isClickable) {
      onCellClick(data);
    }
  };

  const displayText = value ?? data[colDef?.field]; // Use value if available, otherwise fallback to data[colDef?.field]

  const textComponent = (
    <div
      className={b(null, { isClickable })}
      onClick={handleClick}
      data-testid={props['data-testid'] || 'text-renderer'}
    >
      <EllipsisText className={b('text', { isClickable })} text={displayText} />
    </div>
  );

  return isTooltipDisplayed ? (
    <MessageTooltip
      content={formatMessage('TERRITORY_SHEET_GRID_EDIT_UNALLOWED_TOOLTIP')}
      target={textComponent}
      placement={'top'}
    />
  ) : (
    textComponent
  );
};

export default TextRenderer;
